module.exports = __webpack_public_path__ + "img/panda4.dfe484d8.png";